import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		token: {},
    user: {
      head_img: localStorage.getItem('headimg'),
      name: localStorage.getItem('userName')
    },
	},
	mutations: {
		SET_USER:(state) => {
			state.user = {
        head_img: localStorage.getItem('headimg'),
        name: localStorage.getItem('userName')
      };
		}
	},
	actions: {
		setUser({ commit }){
			commit('SET_USER')
		}
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js